import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { useRef } from 'react';

interface ICaShippingLabelModalProps {
  children: any;
  closeWindowPortal: any;
}

const CaShippingLabelWIndow: React.FC<ICaShippingLabelModalProps> = props => {
  const {
    children,
    closeWindowPortal,
  } = props;

  const externalWindow = useRef(
    window.open("", "", "width=900,height=500,left=200,top=200")
  );

  const containerEl = document.createElement("div");

  React.useEffect(() => {
    const currentWindow = externalWindow.current;
    return () => currentWindow.close();
  }, []);

  externalWindow.current.document.title = "A React portal window";
  externalWindow.current.document.body.appendChild(containerEl);

    return ReactDOM.createPortal(children, containerEl);
};
export default CaShippingLabelWIndow;